// MIDAS V3 — `.cc` dev-surface gate (shared)
//
// Relocated from the retired model-compare chip (MODEL_PICKER_SPEC §3/§5):
// the upcoming per-thread model picker (and any other `.cc`-only dev/QA
// affordance) gates its RENDERING on this hostname check.
//
// UX-ONLY gate: the REAL boundary is server-side (the bot's Origin/Referer
// allowlist, fail-closed). Never treat this client hostname check as the
// security boundary.
//
// Two conditions, both required (2026-08-19, TAJMAC-PILOT review F3):
//   1. hostname is `.cc` — unchanged.
//   2. the user is NOT a MidasPilot.
// Why (2): the Tajmac pilot's own invite email points at the `.cc` host
// (MIDAS_PILOT_ROLE_SPEC.md §7 accepts that link deliberately), so a pilot WILL log in
// on `app.machine-id.cc` and the hostname test alone would hand an external OEM the
// 10-model picker, pipeline toggles, composer dev menu, attach-chat and raw thinking
// text — the exact opposite of "nothing but the MIDAS interface" (§10.1).
//
// The role check lives HERE rather than at the ~11 call sites (ModelPickerV3,
// ComposerMenuV3, PipelineToggleV3, MidasHistoryRailV3, ChatBotMessageV3 ×2,
// ChatMessageListV3, MidasChatAreaV3, chatBotSlice ×2) so that every present AND
// future affordance inherits it and none can be forgotten. Non-pilot behaviour on
// `.cc` is byte-identical: the new clause can only ever subtract, and only for one
// role. Still fail-closed — any throw yields false, i.e. affordances hidden.
import accountContext from "../../../../account/accountContext";
import { Roles } from "../../../../account/models/AccountModels";

/** `.cc`-only surface check, excluding MidasPilot users. UX gate only — the server
 *  allowlist is the real gate. */
export const isCcDevSurface = (): boolean => {
  try {
    if (accountContext.user?.role === Roles.MIDAS_PILOT) {
      return false;
    }

    return (
      typeof window !== "undefined" &&
      window.location.hostname === "app.machine-id.cc"
    );
  } catch {
    return false;
  }
};
